<template>
  <div id="vanber">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>岗位管理</el-breadcrumb-item>
      <el-breadcrumb-item>双选会岗位发布</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" class="formBox">

      <el-row>
        <el-form-item label="合作学校" prop="school_id">
          <el-select v-model="form.school_id" filterable placeholder="请选择合作学校">
            <el-option
              v-for="item in douSchoolList"
              :key="item.school_id"
              :label="item.school_name"
              :value="item.school_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-col :span="12">
          <el-form-item label="职位名称" prop="job_name">
            <el-input v-model="form.job_name" placeholder="请输入职位名称" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职位类型" prop="job_type">
            <el-select v-model="form.job_type" placeholder="请选择职位类型">
              <el-option
                v-for="item in jobType"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="薪资待遇" prop="salary">
            <el-select v-model="form.salary_start" placeholder="最低薪资" class="w">
              <el-option
                v-for="item in salaryList"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select v-model="form.salary_end" placeholder="最高薪资" class="w">
              <el-option
                v-for="item in salaryList"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="食宿安排" prop="food_bed">
            <el-select v-model="form.food_bed" placeholder="选择食宿安排">
              <el-option
                v-for="item in foodList"
                :key="item.id"
                :label="item.value"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="年龄要求">
            <el-select v-model="form.age_require">
              <el-option label="不限" value="不限"></el-option>
              <el-option label="18岁以上" value="18岁以上"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学历要求" prop="education">
            <el-select v-model="form.education" placeholder="请选择学历要求">
              <el-option
                v-for="item in educationList"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="招聘人数" prop="recruitment">
            <el-input v-model="form.recruitment" placeholder="请输入人数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作城市" prop="city_id">
            <el-select placeholder="省" v-model="form.province_id" @change="provChange" class="w">
              <el-option
                v-for="item in $store.state.provinces"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select placeholder="市" v-model="form.city_id" ref="city" class="w">
              <el-option
                v-for="item in cityList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="工作地点" prop="job_address">
            <el-input v-model="form.job_address" placeholder="请输入详细地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="截止时间">
            <!-- <el-date-picker v-model="form.end_time" type="date" placeholder="选择日期"></el-date-picker> -->
            <el-date-picker
              v-model="form.end_time"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期时间"
              class="w100"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="职位诱惑" prop="job_attraction">
        <el-input v-model="form.job_attraction" placeholder="请输入岗位亮点"></el-input>
      </el-form-item>
      <el-form-item label="职位描述">
        <div id="wangeditor">
          <div ref="editorElem" style="text-align:left;"></div>
        </div>
      </el-form-item>
      <el-row class="btn">
        <el-button type="primary" @click="onSubmit('form')">确认发布</el-button>
      </el-row>
    </el-form>

     <!-- 根据选双选会学校 -->
    <el-dialog
      title="请先选择一所双选会学校"
      :visible.sync="chooseDouSchoolDialog"
      width="800px"
      class="chooseSchool"
    >
     <el-autocomplete
        popper-class="my-autocomplete"
        v-model="schoolId"
        style="width:300px"
        placeholder="请输入内容"
       :fetch-suggestions="querySearch"
        @select="handleSelect">
        <i
          class="el-icon-edit el-input__icon"
          slot="suffix"
          @click="handleIconClick">
        </i>
        <template slot-scope="{ item }">
          <div class="name">{{ item.value }}</div>
          <span class="addr">{{ item.address }}</span>
        </template>
      </el-autocomplete>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="chooseSchoolDialog = false">确 定</el-button> -->
      </div>
    </el-dialog>

    <!-- 根据省份选学校 -->
    <el-dialog
      title="请先选择一所学校"
      :visible.sync="chooseSchoolDialog"
      width="800px"
      class="chooseSchool"
    >
    <div class="allProvince">
      <span
        v-for="(item,index) in allSchool"
        :key="index"
        class="item"
        :class="{ active:index===number}"
        @click="chooseProv(index,item)"
      >{{item.province}}</span>
    </div>
      <div class="inputSchool">
        <el-input
          placeholder="请输入内容"
          style="width:300px"
          v-model="schoolName"
          @input="searchSchool"
        ></el-input>
        <span style="color:red;margin-left:10px" v-if="schoolList2.length == 0">未搜索到学校</span>
      </div>
      <div class="schoolList">
        <div
          class="line"
          v-for="(item,index) in schoolList2"
          :key="index"
          @click="chooseSchool(item.school_id)"
        >
          <div class="schoolName">{{item.school_name}}</div>
          <div class="count">
            <span>平台学生数量</span>
            <span class="fontColor">{{item.current_student_num}}</span>人
            <span style="margin-left:20px">专业</span>
            <span class="fontColor">{{item.major_num}}</span>个
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chooseSchoolDialog = false">取 消</el-button>
        <!-- <el-button type="primary" @click="chooseSchoolDialog = false">确 定</el-button> -->
      </div>
    </el-dialog>

    <!-- 选择发布时长弹出框 -->
    <el-dialog title="请进行岗位发布认证" :visible.sync="dialogFormVisible" width="500px">
      <div class="infoText">当前岗位发布需认证付费，请选择您要发布的岗位有效月份数，并完成付费认证，即可开启招聘！付费后您的岗位排名TOP10%！</div>
      <el-form class="formBox">
        <div v-if="isArray">
          <el-radio v-model="monthRadio" :label="payInfo[0].code">{{payInfo[0].value}}元/1个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[1].code">{{payInfo[1].value}}元/2个月</el-radio>
          <el-radio v-model="monthRadio" :label="payInfo[2].code">{{payInfo[2].value}}元/3个月</el-radio>
        </div>
        <div v-else>
          <el-radio v-model="monthRadio" :label="payInfo.code">{{payInfo.value}}元/年</el-radio>
        </div>
      </el-form>
      <div class="red">平台建议：岗位有效期越久排名越靠前，平台投递人数会更多</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="toPlatformList()">取 消</el-button>
        <el-button type="primary" @click="chooseMonth()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import E from "wangeditor";
import axios from "axios";
import baseUrl from "@/api/baseUrl.js";
import qs from "qs";
import formatter from "@/assets/js/mixins/formatter";

export default {
  mixins: [formatter],
  name: "Editor",
  data() {
    let checkProvAndCity = (rule, value, callback) => {
      if (!value) {
        callback(new Error("省市必填"));
      } else if (!this.$refs.city.value) {
        callback(new Error("市级必填"));
      } else {
        callback();
      }
    };
    return {
      cityList: [],
      salaryList: [], // 岗位待遇
      foodList: [], //食宿安排情况
      jobType: [], //岗位类型
      educationList: [], // 学历类型
      schoolId:'',
      // 验证规则
      rules: {
        school_id: [{ required: true, message: "请选择学校", trigger: "change" }],
        job_name: [{ required: true, message: "请输入岗位", trigger: "blur" }],
        city_id: [
          {
            required: true,
            validator: checkProvAndCity,
            trigger: ["blur", "change"]
          }
        ],
        job_address: [
          { required: true, message: "请输入岗位详细地址", trigger: "blur" }
        ],
        job_type: [
          {
            required: true,
            message: "请选择岗位类型",
            trigger: ["blur", "change"]
          }
        ],
        food_bed: [
          {
            required: true,
            message: "请选择食宿安排",
            trigger: ["blur", "change"]
          }
        ],
        education: [
          {
            required: true,
            message: "请选择学历要求",
            trigger: ["blur", "change"]
          }
        ],
        job_detail: [
          { required: true, message: "请输入岗位描述", trigger: "blur" }
        ],
        job_attraction: [
          { required: true, message: "请输入岗位吸引力", trigger: "blur" }
        ],
        request: [
          { required: true, message: "请输入岗位要求", trigger: "blur" }
        ],
        recruitment: [
          {
            required: true,
            message: "请输入招聘人数",
            trigger: "blur"
          }
        ],
        salary: [{ required: true, message: "请选择岗位待遇" }],
        expect_start: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        expect_end: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ]
      },
      form: {
        school_id: "",
        // id: localStorage.getItem("token"),
        job_name: "", //岗位
        province_id: null,
        city_id: null,
        province: null,
        city: null,
        age_require: "",
        contact: "", //联系人
        email: "", //email
        telephone: "", //联系人电话
        job_address: "", //岗位详细地址
        job_detail: "", //岗位描述
        job_attraction: "", //岗位吸引力
        request: "", //岗位要求
        remark: "", //备注
        recruitment: "100", //招聘人数
        salary_start: "",
        salary_end: "",
        salary: "", //岗位待遇
        expect_start: "", //到岗时间
        expect_end: "", //过期时间
        food_bed: "", //食宿安排情况
        expect_major: "", //对口专业
        end_time: "", //截止时间
        job_type: "", // 岗位类型
        education: "" // 学历要求
      },
      // tip: true,
      operate: this.$route.query.operate, // 操作类型（添加：add，修改：update）
      jobFee: "",
      editor: null,
      editorContent: "",
      dialogFormVisible: false,
      pay_jobId: "",
      monthRadio: "", // 付费单选按钮的值
      isArray: true, // 判断payInfo是数组还是对象
      payInfo: [
        { code: 0, value: 0 },
        { code: 0, value: 0 },
        { code: 0, value: 0 }
      ],
      schoolId: "",
      // schoolList: [],
      schoolDialog: false,
      chooseSchoolDialog: false,
      chooseDouSchoolDialog:false,
      allSchool: [],
      allSchoolList: [],
      schoolList: [],
      schoolList2: [],
      douSchoolList:[],
      // allProvince: ["全部"],
      number: 0,
      schoolName: ""
    };
  },
  watch: {
    "form.recruitment"(newVal) {
      if (!/^[1-9]\d*$/.test(newVal)) {
        this.$message.error("请输入纯数字！");
        this.form.recruitment = "";
      }
    },
    "form.salary_start"(val) {
      if (val) {
        if (this.form.salary_end) {
          this.form.salary = `${val} ~ ${this.form.salary_end}`;
        } else {
          this.form.salary = `${val}`;
        }
      }
    },
    "form.salary_end"(val) {
      if (val && this.form.salary_start) {
        this.form.salary = `${this.form.salary_start} ~ ${val}`;
      }
    },
    "form.province_id"(val) {
      if (val) {
        this.form.province = this.formatProv(val);
      }
    },
    "form.city_id"(val) {
      if (val) {
        this.form.city = this.formatCity(this.cityList, val);
      }
    }
  },
  mounted() {
    // 富文本
    this.editor = new E(this.$refs.editorElem);
    // 编辑器的事件，每次改变会获取其html内容
    this.editor.customConfig.onchange = html => {
      this.editorContent = html;
    };
    this.editor.customConfig.menus = [
      // 菜单配置
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      // "fontName", // 字体
      // "italic", // 斜体
      // "underline", // 下划线
      // "strikeThrough", // 删除线
      "foreColor" // 文字颜色
      // "backColor", // 背景颜色
      // "link", // 插入链接
      // "list", // 列表
      // "justify", // 对齐方式
      // "quote", // 引用
      // "emoticon", // 表情
      // "image", // 插入图片
      // "table", // 表格
      // "code", // 插入代码
      // "undo", // 撤销
      // "redo" // 重复
    ];
    this.editor.create(); // 创建富文本实例

    // this.getAllSchool();
    this.getDoubleSchool()
    // this.getPayInfo();
    this.getOption();
    if (
      this.$route.query.operate === "update" ||
      this.$route.query.operate == "other"
    ) {
      let job = JSON.parse(localStorage.getItem("job"));
      if (job.province_id) {
        this.getXixunCity(job.province_id);
      }
      for (let key in this.form) {
        this.form[key] = job[key];
      }
      if (job.food_bed_id != 0) {
        this.form.food_bed = job.food_bed_id;
      }
      this.editor.txt.html(this.form.job_detail);
    }
  },
  methods: {
    async getXixunCity(provinceId) {
      let res = await this.$api.common.getXixunCity(provinceId);
      if (res.code === 0) {
        this.cityList = res.data;
      }
    },
    async getDoubleSchool() {
      let res = await this.$api.school.getDoubleSchool();
      if (res.code === 0) {
        this.douSchoolList = res.data;
      }
    },
    provChange(provId) {
      this.cityList = null;
      this.form.city_id = null;
      this.getXixunCity(provId);
    },
    async getOption() {
      let salary = await this.$api.common.getSalaryList();
      if (salary.code === 0) {
        this.salaryList = salary.data;
      }
      let food = await this.$api.common.getTypeList("food_bed");
      if (food.code === 0) {
        this.foodList = food.data;
      }
      let type = await this.$api.common.getJobType();
      if (type.code === 0) {
        this.jobType = type.data;
      }
      let education = await this.$api.common.getEducationList();
      if (education.code === 0) {
        this.educationList = education.data;
      }
    },
    async getAllSchool() {
      var data1 = JSON.parse(localStorage.getItem("qxySchool"));
      let schoolObj = data1;
      let schoolArr = [];
      for (var key in schoolObj) {
        schoolArr.push(schoolObj[key]);
      }
      schoolArr.unshift({ province: "全部", items: [] });
      this.allSchool = schoolArr;
      schoolArr.forEach((item, index) => {
        this.allSchoolList = this.allSchoolList.concat(item.items);
        this.schoolList = this.allSchoolList;
        this.schoolList2 = this.allSchoolList;
      });

      let res = await this.$api.school.getAllSchool();
      // if (res.code == 0) {
      //   let schoolObj = res.data;
      //   let schoolArr = [];
      //   for (var key in schoolObj) {
      //     schoolArr.push(schoolObj[key]);
      //   }
      //   schoolArr.unshift({ province: "全部", items: [] });
      //   this.allSchool = schoolArr;
      //   schoolArr.forEach((item, index) => {
      //     this.allSchoolList = this.allSchoolList.concat(item.items);
      //     this.schoolList = this.allSchoolList;
      //     this.schoolList2 = this.allSchoolList;
      //   });
      // }
    },
    chooseProv(index, item) {
      this.number = index;
      if (index == 0) {
        this.schoolList = this.allSchoolList;
        this.schoolList2 = this.schoolList;
      } else {
        this.schoolList = item.items;
        this.schoolList2 = this.schoolList;
      }
    },
    searchSchool(val) {
      this.schoolList2 = [];
      this.schoolList.forEach(item => {
        if (item.school_name.indexOf(val) != -1) {
          this.schoolList2.push(item);
        }
      });
    },
    onSubmit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.form.job_detail = this.editor.txt.html();
          // this.form.school_id = this.$route.query.schoolId;
          this.jobAdd();
        } else {
          return false;
        }
      });
    },
    async jobAdd() {
      let res = null;
      if (this.form.salary.indexOf("面议") == -1) {
        if (
          parseInt(
            this.form.salary_start.substring(
              0,
              this.form.salary_start.length - 1
            )
          ) >
          parseInt(
            this.form.salary_end.substring(0, this.form.salary_end.length - 1)
          )
        ) {
          this.$message({
            message: "最低薪资不能大于最高薪资!",
            type: "warning",
            center: true
          });
          return;
        }
      }
      if (
        this.$route.query.operate === "add" ||
        this.$route.query.operate == "other"
      ) {
        // 不需要选择学校
        let params = this.delNullVal(this.form);

        // 调用添加岗位接口
        let res = await this.$api.job.addDouJob(params);
        if (res.code == 0) {
          this.$message({
            message: "岗位发布成功",
            type: "success"
          });
          setTimeout(() => {
            this.$router.push({
              path: "/schoolJobList"
            });
          }, 600);

          // let jobId = res.data.id;
          // this.pay_jobId = jobId;
          // // 判断是否需要跳转付费界面
          // let requirePay = res.data.requirePay;
          // if (requirePay == "yes") {
          //   // 显示选择发布时长并跳转付费页面对话框
          //   this.getPayInfo(schoolId);
          //   this.dialogFormVisible = true;
          // } else if (requirePay == "no") {
          //   this.$confirm("岗位发布成功，联系管理员快速审核", "提示", {
          //     confirmButtonText: "确定",
          //     cancelButtonText: "取消",
          //     type: "success"
          //   })
          //     .then(() => {
          //       this.$router.push({
          //         path: "/schoolJobList"
          //       });
          //     })
          //     .catch(() => {
          //       this.$router.push({
          //         path: "/schoolJobList"
          //       });
          //     });
          // }

          // 显示选择发布时长并跳转付费页面对话框
          // this.dialogFormVisible = true;
        }

        // 需要选择学校
        // this.chooseSchoolDialog = true;
        // return;
      } else if (this.$route.query.operate == "addSchoolJob") {
        this.form.school_id = this.$route.query.schoolId;
        this.schoolId = this.$route.query.schoolId;
        let params = this.delNullVal(this.form);
        // 调用添加岗位接口
        res = await this.$api.job.addSchoolJob(params);
      } else if (this.$route.query.operate === "update") {
        let job = JSON.parse(localStorage.getItem("job"));
        let params = this.delNullVal(this.form);
        res = await this.$api.job.updateJob(job.id, params);
      }

      if (res.code === 0) {
        let jobId = res.data.id;
        this.pay_jobId = jobId;
        if (this.$route.query.operate === "addSchoolJob") {
          let requirePay = res.data.requirePay;
          if (requirePay == "yes" || requirePay == "no") {
          //   this.getPayInfo(this.schoolId);
          //   this.dialogFormVisible = true;
          // } else if (requirePay == "no") {
            this.$confirm("岗位发布成功，联系管理员快速审核", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "success"
            })
              .then(() => {
                this.$router.push({
                  path: "/schoolJobList"
                });
              })
              .catch(() => {
                this.$router.push({
                  path: "/schoolJobList"
                });
              });
          }
        } else if (this.$route.query.operate === "update") {
          this.$message({
            message: "编辑成功!",
            type: "success",
            center: true
          });
          this.$router.go(-1);
        }
      }
    },
    // 选择学校后发布岗位
    async chooseSchool(schoolId) {
      if (!schoolId) {
        this.$message({
          message: "你还没有选择学校",
          type: "warning"
        });
        return;
      }
      this.schoolId = schoolId;

      this.chooseSchoolDialog = false;
      this.form.school_id = this.schoolId;

      let params = this.delNullVal(this.form);

      // 调用添加岗位接口
      let res = await this.$api.job.addSchoolJob(params);
      if (res.code === 0) {
        let jobId = res.data.id;
        this.pay_jobId = jobId;
        // 判断是否需要跳转付费界面
        let requirePay = res.data.requirePay;
        if (requirePay == "yes"||requirePay == "no") {
          // 显示选择发布时长并跳转付费页面对话框
        //   this.getPayInfo(schoolId);
        //   this.dialogFormVisible = true;
        // } else if (requirePay == "no") {
          this.$confirm("岗位发布成功，联系管理员快速审核", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success"
          })
            .then(() => {
              this.$router.push({
                path: "/schoolJobList"
              });
            })
            .catch(() => {
              this.$router.push({
                path: "/schoolJobList"
              });
            });
        }

        // 显示选择发布时长并跳转付费页面对话框
        // this.dialogFormVisible = true;
      }
    },
    async getPayInfo(schoolId) {
      let res = await this.$api.pay.getEnterpriseJobFee({
        school_id: schoolId
      });
      if (res.code == 0) {
        this.payInfo = res.data;
        if (!Array.isArray(res.data)) {
          this.isArray = false;
          this.monthRadio = res.data.code;
        }
      }
    },
    chooseMonth() {
      if (this.monthRadio == "") {
        this.$message("请选择一个付费项目");
        return;
      }
      this.dialogFormVisible = false;
      this.payJobFee(this.pay_jobId, this.monthRadio);
    },
    payJobFee(jobId, month) {
      let params = {
        subject: "校企合作岗位服务费",
        type: "web",
        school_id: this.schoolId,
        job_id: jobId,
        fee_type: month
      };
      // console.log(params);
      // return

      axios
        .post(
          baseUrl + "api/enterprise/pay/enterprise_job/alipay/index",
          qs.stringify(params),
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.data.code && res.data.code !== 0) {
            this.$message.error(res.data.msg);
            return;
          }
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[document.forms.length - 1].acceptCharset = "GBK"; //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
          document.forms[document.forms.length - 1].submit();
        });
    },
    toPlatformList() {
      this.dialogFormVisible = false;

      this.$router.push({
        path: "/schoolJobList"
      });
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .w-e-toolbar .w-e-menu {
  z-index: 15 !important;
}
/deep/ .w-e-text-container {
  position: relative;
  z-index: 10 !important;
}
#vanber {
  position: relative;
  padding: 20px;

  .formBox {
    width: 900px;
    margin: 40px 0 0 40px;

    .el-row {
      margin-bottom: 0px;
    }

    .btn {
      padding-left: 50px;
      text-align: center;
      padding-top: 30px;
      .el-button {
        width: 286px;
      }
    }
    .el-select {
      width: 100%;
    }
    .w {
      width: 50%;
    }
    .w100 {
      width: 100%;
    }
  }
  /deep/ .school {
    .el-input {
      .el-input__suffix {
        display: none;
      }
    }
  }
  /deep/ .chooseSchool {
    .el-dialog__body {
      padding: 0px 20px;
      .allProvince {
        .item {
          display: inline-block;
          margin: 0px 8px;
          padding: 5px;
          cursor: pointer;
        }
        .active {
          background: cyan;
        }
      }
      .inputSchool {
        padding-left: 10px;
        margin-top: 10px;
      }
      .schoolList {
        height: 350px;
        margin: 10px;
        padding: 5px;
        border: 1px solid #dcdcdc;
        overflow: auto;
        .line {
          padding: 8px 2px;
          cursor: pointer;
          .schoolName {
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 8px;
          }
          .count {
            font-weight: initial;
            .fontColor {
              color: #ec6941;
            }
          }
        }
        .line:hover {
          background: #dcdcdc;
        }
      }
    }
  }
  /deep/ .el-dialog {
    .el-dialog__body {
      padding: 5px 20px;
      .infoText {
        color: orange;
        margin-bottom: 20px;
      }
      .red {
        color: red;
        margin-top: 20px;
      }
      .el-form {
        margin: 0;
      }
    }
  }
}
</style>
